import { Card, Typography } from '@sonnen/web-ui';
import clsx from 'clsx';
import { useAppContext } from '../../AppContext/AppContext';
import { useTranslation } from '../../i18n/i18n';
import { useOfferContext } from '../../OfferContext/OfferContext';
import { ModuleName } from '../../types';
import { getPriceAfterFirstYear } from '../../utils/utils';
import { ModuleToggle } from '../ModuleToggle/ModuleToggle';
import styles from './ModuleCard.module.css';

type ModuleCardProps = {
  name: ModuleName;
};

export const ModuleCard = ({ name }: ModuleCardProps) => {
  const { t } = useTranslation();
  const { offerLoading, offer } = useOfferContext();
  const { modules } = useAppContext();
  const priceAfterFirstYear =
    getPriceAfterFirstYear(offer, modules) ||
    t('optimizationInfoCard.customer.priceAfterFirstYear');

  return (
    <Card paddingSize="none" className={styles.moduleCard} dataTestId={`${name}-module`}>
      <div
        data-testid="module-toggle"
        className={clsx(styles.actionBox, { [styles.offerLoading]: offerLoading })}
      >
        <div className={styles.cta}>
          <Typography.Label1>{t('optimizationInfoCard.toggle.title')}</Typography.Label1>
          <s>
            <Typography.Body2 variant="secondary">
              {t('optimizationInfoCard.toggle.offer', { value: priceAfterFirstYear })}
            </Typography.Body2>
          </s>
          <Typography.Label2 variant="secondary">
            {t('optimizationInfoCard.toggle.body')}
          </Typography.Label2>
        </div>
        <ModuleToggle name={name} />
      </div>
    </Card>
  );
};
